import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { userService } from '../services/user.service';
import type { AnalysisDimensionFilter } from '../utils/filterComparators';

export function useUserDimensionFilters(userFronteggId: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<AnalysisDimensionFilter[]>({
    queryKey: ['userDimensionFilters', userFronteggId],
    queryFn: () => userService.getUserDimensionFilters(userFronteggId),
    enabled: enabled && !!userFronteggId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateUserDimensionFilters() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      userFronteggId,
      dimensionFilters,
    }: {
      userFronteggId: string;
      dimensionFilters: AnalysisDimensionFilter[];
    }) => userService.updateUserDimensionFilters(userFronteggId, dimensionFilters),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['userDimensionFilters', variables.userFronteggId],
      });
    },
  });
}
